import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {EquipmentData} from '../../types'
import {MainEquipmentsDto} from '../types'

const QueryKey = 'mainEquipments'

type UseMainEquipmentsParams = {
  plantId: string
  language: string
  options?: Omit<UseQueryOptions<EquipmentData[], AxiosError>, 'queryKey'>
}

export const useMainEquipments = ({plantId, language, options}: UseMainEquipmentsParams) => {
  return useQuery<EquipmentData[], AxiosError>({
    queryKey: [QueryKey, language, plantId],
    queryFn: async () => {
      const path = `/shifthandover/${plantId}/config/main-equipments`
      const config = {
        params: {
          language
        }
      }

      const response = await ApiClient.axiosInstance.get<MainEquipmentsDto>(path, config)
      return response.data
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options
  })
}
